import { Navigate, Route, Routes } from "react-router-dom";

import MainLayout from "./layouts/MainLayout/MainLayout";
import {
  AddCampaignPage,
  AddCustomerPage,
  AddItemPage,
  AddNewStockPage,
  AddPurchasePage,
  AddSupplierPage,
  AddSupplyPage,
  CampaignDetailsPage,
  CampaignsPage,
  CustomerDetailsPage,
  CustomersPage,
  DashboardPage,
  EditCampaignPage,
  EditCustomerPage,
  EditSupplierPage,
  EditSupplyPage,
  InventoryPage,
  ItemDetailsPage,
  LoginPage,
  MoveStockPage,
  NotificationsPage,
  OrderDetailsPage,
  OrdersPage,
  PrescriptionFormPage,
  ReportsPage,
  PurchaseDetailsPage,
  PurchasesPage,
  SuppliersDetailsPage,
  SuppliersPage,
  SuppliesPage,
  UpdateItemPage,
} from "./pages";

import AuthGuard from "./guards/AuthGuard";
import PublicAuthGuard from "./guards/PublicAuthGuard";

function Router() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route
          path="/dashboard"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/prescription"
          element={
            <AuthGuard>
            <PrescriptionFormPage />
             </AuthGuard>
          }
        />
        <Route
          path="/notifications"
          element={
            <AuthGuard>
              <NotificationsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/reports"
          element={
            <AuthGuard>
              <ReportsPage />
            </AuthGuard>
          }
        />

        <Route path="inventory">
          <Route
            index
            element={
              <AuthGuard>
                <InventoryPage />
              </AuthGuard>
            }
          />
          <Route
            path="add"
            element={
              <AuthGuard>
                <AddItemPage />
              </AuthGuard>
            }
          />
          <Route
            path="details/:itemId"
            element={
              <AuthGuard>
                <ItemDetailsPage />
              </AuthGuard>
            }
          />
          <Route
            path="edit/:itemId"
            element={
              <AuthGuard>
                <UpdateItemPage />
              </AuthGuard>
            }
          />
          <Route path="stock">
            <Route
              path="add"
              element={
                <AuthGuard>
                  <AddNewStockPage />
                </AuthGuard>
              }
            />
            <Route
              path="move"
              element={
                <AuthGuard>
                  <MoveStockPage />
                </AuthGuard>
              }
            />
          </Route>
        </Route>

        <Route path="orders">
          <Route
            index
            element={
              <AuthGuard>
                <OrdersPage />
              </AuthGuard>
            }
          />
          <Route
            path="details/:orderId"
            element={
              <AuthGuard>
                <OrderDetailsPage />
              </AuthGuard>
            }
          />
        </Route>

        <Route path="purchases">
          <Route
            index
            element={
              <AuthGuard>
                <PurchasesPage />
              </AuthGuard>
            }
          />
          <Route
            path="details/:purchaseId"
            element={
              <AuthGuard>
                <PurchaseDetailsPage />
              </AuthGuard>
            }
          />
          <Route
            path="add"
            element={
              <AuthGuard>
                <AddPurchasePage />
              </AuthGuard>
            }
          />
        </Route>

        <Route path="suppliers">
          <Route
            index
            element={
              <AuthGuard>
                <SuppliersPage />
              </AuthGuard>
            }
          />
          <Route
            path="details/:supplierId"
            element={
              <AuthGuard>
                <SuppliersDetailsPage />
              </AuthGuard>
            }
          />
          <Route
            path="add"
            element={
              <AuthGuard>
                <AddSupplierPage />
              </AuthGuard>
            }
          />
          <Route
            path="edit/:supplierId"
            element={
              <AuthGuard>
                <EditSupplierPage />
              </AuthGuard>
            }
          />
        </Route>

        <Route path="supplies">
          <Route
            index
            element={
              <AuthGuard>
                <SuppliesPage />
              </AuthGuard>
            }
          />
          <Route
            path="add"
            element={
              <AuthGuard>
                <AddSupplyPage />
              </AuthGuard>
            }
          />
          <Route
            path="edit/:supplyId"
            element={
              <AuthGuard>
                <EditSupplyPage />
              </AuthGuard>
            }
          />
        </Route>

        <Route path="customers">
          <Route
            index
            element={
              <AuthGuard>
                <CustomersPage />
              </AuthGuard>
            }
          />
          <Route
            path="details/:customerId"
            element={
              <AuthGuard>
                <CustomerDetailsPage />
              </AuthGuard>
            }
          />
          <Route
            path="add"
            element={
              <AuthGuard>
                <AddCustomerPage />
              </AuthGuard>
            }
          />
          <Route
            path="edit/:customerId"
            element={
              <AuthGuard>
                <EditCustomerPage />
              </AuthGuard>
            }
          />
        </Route>

        <Route path="campaigns">
          <Route
            index
            element={
              <AuthGuard>
                <CampaignsPage />
              </AuthGuard>
            }
          />
          <Route
            path="details/:campaignId"
            element={
              <AuthGuard>
                <CampaignDetailsPage />
              </AuthGuard>
            }
          />
          <Route
            path="add"
            element={
              <AuthGuard>
                <AddCampaignPage />
              </AuthGuard>
            }
          />
          <Route
            path="edit/:campaignId"
            element={
              <AuthGuard>
                <EditCampaignPage />
              </AuthGuard>
            }
          />
        </Route>

        <Route path="*" element={<h1>404</h1>} />
      </Route>
      <Route
        path="/login"
        element={
          <PublicAuthGuard>
            <LoginPage />
          </PublicAuthGuard>
        }
      />
    </Routes>
  );
}

export default Router;
